import React, { Component } from 'react'
import { connect } from 'react-redux'
import Collapse from '@material-ui/core/Collapse'
import Typography from '@material-ui/core/Typography'
import AreaChart from './AreaChart'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetSelectedData } from '../selectors/selectedDataSelector'
import { makeGetData } from '../selectors/dataSelector'
import ObjectActions from '../redux/objectRedux'
import MapActions from '../redux/mapRedux'
import TimeSliderActions from '../redux/timeSliderRedux'
import arrayIsNotEmpty from '../utility/arrayIsNotEmpty'
// import createDatetimeMinMax from '../utility/createDatetimeMinMax'
// import { CircularProgress } from '@material-ui/core/Progress'
// import lookupLandDeformationType from '../utility/lookupLandDeformationType'
import { RED, YELLOW, BLUE } from '../config/colors'
import { createLinearMap } from '../utility/linearMap'

const outputMin = 0
const outputMax = 1
const inputMin = 0
const inputMax = 1
const linearMap = createLinearMap(inputMin, inputMax, outputMin, outputMax)
const tickFormat = tick => `${(tick/100).toFixed(2)}`
const labels = datum => `${(datum.value/100).toFixed(2)} moles/m2`
const chartStyles = {

  scatter: {
    data: {
      strokeWidth: 3,
      stroke: 'gray',
      strokeOpacity: 0.4,
      fill: d => (d.type === 1 ? BLUE : d.type === 2 ? YELLOW : RED)
    }
  }
}

// const chartLabels = {
//   scatter: d =>
//     `${lookupLandDeformationType(d.type)}: ${d.value.toFixed().toLocaleString()}`
// }

class LandDeformationLineChartContainer extends Component {
  shouldComponentUpdate (nextProps) {
    const { data } = this.props

    if (nextProps.data !== data) {
      console.log(data)
      return true
    }
    return false
  }
  
  handleMouseEnter = (event, data) => {}

  handleMouseLeave = (event, data) => {}

  handleClick = (event, data) => {
    const { actions } = this.props
    if (data && data.datum && data.datum.timestamp) {
      console.log(data.datum.timestamp)
      actions.datetimeChanged(data.datum.timestamp)
    }
  }

  render () {
    const { datetime, uuidsHighlighted, data } = this.props
    
    if (!arrayIsNotEmpty(data)) {
      return null
    }

    const maxY = linearMap(Math.max(...data.map(datum => datum.value))) + 0.01
    const minY = linearMap(Math.min(...data.map(datum => datum.value))) - 0.01
    // const filteredData = [
    //   ...data
    //   ]

    const groupByFilters = [item => item]

    return (
      <Collapse
        component='div'
        in={arrayIsNotEmpty(data)}
        unmountOnExit
      >
        <div>
          <Typography>Methane concentration over time</Typography>
        </div>
        <AreaChart
          data={data}
          x={value => new Date(value.timestamp)}
          y={value => linearMap(value.value)}
          minY={minY}
          maxY={maxY}
          tickFormat={tickFormat}
          labels={labels}
          groupByFilters={groupByFilters}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          handleClick={this.handleClick}
          datetime={datetime}          
        />
      </Collapse>
    )
  }
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getSelectedData = makeGetSelectedData()
  const getData = makeGetData()

  const mapStateToProps = state => {
    return {
      data: getData(state, 'LeakDetectionPoint', getFeaturesFromGeoJson),
      datetime: getDatetime(state, 'LeakDetection'),
      fetching: state.data.fetching,
      selectedData: getSelectedData(state, 'MopraWellsites-fill'),
      uuidsSelected: state.object.uuidsSelected,
      uuidsHighlighted: state.object.uuidsHighlighted
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      datetimeChanged:  datetime => dispatch(TimeSliderActions.timeSliderValueUpdated(datetime))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  LandDeformationLineChartContainer
)



// WEBPACK FOOTER //
// ./src/charts/LeakDetectionLineChart.js